<template>
  <div class="container" :style="`background-image: url(${detailBack})`">
    <!-- <Header :theme="theme" :position="'relative'"></Header> -->
    <div :class="`content in`">
      <div class="text">
        <p class="title">隐私条款</p>
        <p class="info">1.用户信息公开情况说明</p>
        <p class="info">尊重用户个人隐私是一项基本政策。所以，不会在未经合法用户授权时公开、编辑或透露其注册资料及保存在本网站中的非公开内容，除非有下列情况：</p>
        <p class="info">（1）有关法律规定或合法服务程序规定；</p>
        <p class="info">（2）在紧急情况下，为维护用户及公众的权益；</p>
        <p class="info">（3）为维护浩伟智能的商标权、专利权及其他任何合法权益；</p>
        <p class="info">2.用户信息收集</p>
        <p class="info">（1）用户信息收集使用目的：浩伟智能会收集用户的手机号或邮箱进行账号的注册与登录，还会收集用户的IP地址，用来判别用户所在区域；</p>
        <p class="info">（2）用户信息收集使用范围：浩伟智能保证不会泄露用户信息；</p>
        <p class="info">（1）请勿以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；</p>
        <p class="info">（2）冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关的名称；</p>
        <p class="info">设备信息：设备标识符（IMEI、IDFA、Android ID、MAC、OAID等相关信息）</p>
        <p class="info">网站信息（网站崩溃信息、通知开关状态、软件列表等相关信息）、设备参数及系统信息（设备类型、设备型号、操作系统及硬件相关信息；</p>
        <p class="info">网络信息：IP地址，WiFi信息，基站信息等相关信息网络信息：IP地址，WiFi信息，基站信息等相关信息；</p>
        <p class="info">3.隐私权政策适用范围</p>
        <p class="info">（1）用户在登录本网站服务器时留下的个人身份信息；</p>
        <p class="info">（2）用户通过本网站服务器与其他用户或非用户之间传送的各种资讯；</p>
        <p class="info">（3）本网站与商业伙伴共享的其他用户或非用户的各种信息；</p>
        <p class="info">4.资讯公开与共享</p>
        <p class="info">（1）用户本人同意与第三方共享信息和资讯;</p>
        <p class="info">（2）只有透露用户的个人信息和资讯，才能提供用户所要求的某种产品和服务;</p>
        <p class="info">（3）应代表本网站提供产品或服务的主体的要求提供（除非我们另行通知，否则该等主体无权将相关用户个人信息和资讯用于提供产品和服务之外的其他用途）：根据法律法规或行政命令的要求提供;因外部审计需要而提供;用户违反了本网站服务条款或任何其他产品及服务的使用规定;经本站评估，用户的帐户存在风险，需要加以保护。</p>
        <p class="info">5.Cookies、日志档案和webbeacon</p>
        <p class="info">通过使用cookies，本网站向用户提供简单易行并富个性化的网络体验。cookies能帮助我们确定用户连接的页面和内容，并将该等信息储存。我们使用自己的cookies和webbeacon，用于以下用途：</p>
        <p class="info">（1）记住用户身份。例如：cookies和webbeacon有助于我们辨认用户作为我们的注册用户的身份，或保存用户向我们提供有关用户的喜好或其他信息；</p>
        <p class="info">（2）分析用户使用我们服务的情况。我们可利用cookies和webbeacon来了解用户使用我们的服务进行什么活动、或哪些网页或服务最受欢迎； 我们为上述目的使用cookies和webbeacon的同时，可能将通过cookies和webbeacon收集的非个人身份信息汇总提供给广告商和其他伙伴，用于分析您和其他用户如何使用我们的服务并用于广告服务。用户可以通过浏览器或用户选择机制拒绝或管理cookies或webbeacon。但请用户注意，如果用户停用cookies或webbeacon，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。</p>
        <p class="info">（3）当你使用本站的服务时，我们的主机会自动记录用户的浏览器在访问网站时所发送的信息和资讯。主机日志资讯包括但不限于用户的网路请求、IP地址、浏览器类型、浏览器使用的语言、请求的日期和时间，以及一个或多个可以对用户的浏览器进行辨识的cookie。</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/layout/Header"
export default {
  components:{
    Header,
  },
  data(){
    return{
      theme:"black",
      detailBack:"http://www.hwznsoft.com/files/png/16B26BDA974A472686E4652D45D75C76.png",
    }
  },
  created(){
  },
  methods:{
  }
}
</script>
<style lang="scss" scoped>
.container{
  width: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: auto;
  height: 100vh;

  .content{
    width: 100rem;
    min-height: 27.5rem;
    margin: 0 auto;
    color: #373737;

    .text{
      // margin: 1.25rem 0;
      margin: 2.5rem 0;
      // height: 40.625rem;

      .title{
        text-align: center;
        margin: 1.25rem 0;
        font-size: 2.1875rem;
        line-height: 2.5rem;
        font-weight: bold;
      }
      .info{
        margin-top: 1.0625rem;
        // color: #9A9A9A;
        font-size: 1.125rem;
        line-height: 1.5625rem;
        text-indent: 2.5rem;
      }
      .content{
        margin-top: 2rem;
        // height: 25rem;
        // max-height: 25rem;
        // min-height: 25rem;
        overflow:auto;
      }
      .recommend{
        margin-top: 3.75rem;

        .tip{
          color: #9A9A9A;
          font-size: .875rem;
          line-height: 1rem;
          cursor: pointer;
        }
        .tip:hover{
          color: #124FB0;
        }
      }
    }
  }

  .in{
    .text{
      animation: show 2s ease-out;
    }
    .title{
      animation: transIn 2s ease-out;
    }
  }
  .out{
    .text{
      animation: hidden 2s ease-out;
    }
    .title{
      animation: transOut 2s ease-out;
    }
  }
  @keyframes show {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes hidden {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
}
</style>